import { render, staticRenderFns } from "./ConsentLetterPage.vue?vue&type=template&id=e33cc8a2"
import script from "./ConsentLetterPage.vue?vue&type=script&lang=js"
export * from "./ConsentLetterPage.vue?vue&type=script&lang=js"
import style0 from "./ConsentLetterPage.vue?vue&type=style&index=0&id=e33cc8a2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports